import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, createBlock as _createBlock } from "vue";
import ResourceGroupListRow from "@/components/admin/ResourceGroupListRow.vue";
import { useRouter } from "vue-router";
import { ResourceType } from "@/model/enum/ResourceType";
export default /*@__PURE__*/ _defineComponent({
    __name: 'ResourceGroupList',
    props: {
        resourceGroups: { type: Array, required: true },
        type: { type: String, required: true }
    },
    setup(__props) {
        const props = __props;
        const router = useRouter();
        function rowClick(clickedResourceGroup) {
            router.push({ name: 'admin-resource-groups-edit', params: { id: clickedResourceGroup.id.toString() } });
        }
        function createResourceGroup() {
            router.push({ name: 'admin-resource-groups-new', params: { resourceType: props.type.toString() } });
        }
        return (_ctx, _cache) => {
            const _component_v_container = _resolveComponent("v-container");
            const _component_v_btn = _resolveComponent("v-btn");
            const _component_v_table = _resolveComponent("v-table");
            const _component_v_card = _resolveComponent("v-card");
            return (_openBlock(), _createBlock(_component_v_card, { class: "d-flex flex-wrap ma-0" }, {
                default: _withCtx(() => [
                    _createVNode(_component_v_container, { class: "d-flex v-col-12 justify-start" }, {
                        default: _withCtx(() => [
                            _createVNode(_component_v_container, { class: "text-h4 text-start ma-0 pa-0" }, {
                                default: _withCtx(() => [
                                    (__props.type == _unref(ResourceType).RESOURCE)
                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                            _createTextVNode("Ressourcengruppen")
                                        ], 64))
                                        : (__props.type == _unref(ResourceType).ATTRIBUTE)
                                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                _createTextVNode("Eigenschaftengruppe")
                                            ], 64))
                                            : _createCommentVNode("", true)
                                ]),
                                _: 1
                            }),
                            _createVNode(_component_v_btn, {
                                onClick: _cache[0] || (_cache[0] = ($event) => (createResourceGroup()))
                            }, {
                                default: _withCtx(() => [
                                    (__props.type == _unref(ResourceType).RESOURCE)
                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                            _createTextVNode("Neue Ressourcengruppe anlegen")
                                        ], 64))
                                        : (__props.type == _unref(ResourceType).ATTRIBUTE)
                                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                _createTextVNode("Neue Eigenschaftengruppe anlegen")
                                            ], 64))
                                            : _createCommentVNode("", true)
                                ]),
                                _: 1
                            })
                        ]),
                        _: 1
                    }),
                    _createVNode(_component_v_container, { fluid: true }, {
                        default: _withCtx(() => [
                            _createVNode(_component_v_table, null, {
                                default: _withCtx(() => [
                                    _cache[1] || (_cache[1] = _createElementVNode("thead", null, [
                                        _createElementVNode("tr", null, [
                                            _createElementVNode("th", null, "ID"),
                                            _createElementVNode("th", null, "Name"),
                                            _createElementVNode("th", { class: "text-center" }, "Enthält")
                                        ])
                                    ], -1)),
                                    _createElementVNode("tbody", null, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.resourceGroups, (resourceGroup, index) => {
                                            return (_openBlock(), _createBlock(ResourceGroupListRow, {
                                                class: "cursor-pointer",
                                                key: index,
                                                "resource-group": resourceGroup,
                                                onClick: ($event) => (rowClick(resourceGroup))
                                            }, null, 8, ["resource-group", "onClick"]));
                                        }), 128))
                                    ])
                                ]),
                                _: 1
                            })
                        ]),
                        _: 1
                    })
                ]),
                _: 1
            }));
        };
    }
});
